import React from 'react';
import { Link } from 'react-router-dom';
import AdPlaceholder from './AdPlaceholder';
import './Home.css';

const Home = () => {
  const features = [
    {
      icon: '⚡',
      title: 'Quick CGPA Calculator',
      description: 'Calculate your CGPA instantly with our simple interface'
    },
    {
      icon: '📊',
      title: 'Detailed Tracking',
      description: 'Track courses, semesters, and grade distribution'
    },
    {
      icon: '🎯',
      title: 'Target Calculator',
      description: 'Find out what grades you need to achieve your goals'
    },
    {
      icon: '💾',
      title: 'Auto-Save',
      description: 'Your data is automatically saved in your browser'
    }
  ];

  return (
    <div className="home-page">
      <AdPlaceholder position="top" />
      
      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-content">
          <h1 className="hero-title">
            Calculate Your VIT CGPA
            <span className="hero-subtitle">Simple. Fast. Accurate.</span>
          </h1>
          <p className="hero-description">
            The most intuitive CGPA calculator for VIT students. Track your academic performance, 
            set targets, and achieve your goals.
          </p>
          
          <div className="cta-buttons">
            <Link to="/calculator" className="cta-primary">
              Start Calculating
            </Link>
            <Link to="/faq" className="cta-secondary">
              Learn More
            </Link>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="features-section">
        <h2 className="section-title">Everything You Need</h2>
        <div className="features-grid">
          {features.map((feature, index) => (
            <div key={index} className="feature-card">
              <div className="feature-icon">{feature.icon}</div>
              <h3 className="feature-title">{feature.title}</h3>
              <p className="feature-description">{feature.description}</p>
            </div>
          ))}
        </div>
      </section>

      {/* How It Works */}
      <section className="how-it-works">
        <h2 className="section-title">How It Works</h2>
        <div className="steps-container">
          <div className="step">
            <div className="step-number">1</div>
            <h3>Enter Your Courses</h3>
            <p>Add course names, credits, and grades for each semester</p>
          </div>
          <div className="step-arrow">→</div>
          <div className="step">
            <div className="step-number">2</div>
            <h3>Calculate Instantly</h3>
            <p>Get your CGPA, GPA per semester, and percentage</p>
          </div>
          <div className="step-arrow">→</div>
          <div className="step">
            <div className="step-number">3</div>
            <h3>Plan Ahead</h3>
            <p>Use target calculator to see what grades you need</p>
          </div>
        </div>
      </section>

      {/* Grade Scale Reference */}
      <section className="grade-scale">
        <h2 className="section-title">VIT Grade Scale</h2>
        <div className="grade-table-container">
          <table className="grade-table">
            <thead>
              <tr>
                <th>Grade</th>
                <th>Grade Points</th>
                <th>Marks Range</th>
                <th>Description</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td><span className="grade-badge grade-s">S</span></td>
                <td>10</td>
                <td>90-100</td>
                <td>Outstanding</td>
              </tr>
              <tr>
                <td><span className="grade-badge grade-a">A</span></td>
                <td>9</td>
                <td>80-89</td>
                <td>Excellent</td>
              </tr>
              <tr>
                <td><span className="grade-badge grade-b">B</span></td>
                <td>8</td>
                <td>70-79</td>
                <td>Very Good</td>
              </tr>
              <tr>
                <td><span className="grade-badge grade-c">C</span></td>
                <td>7</td>
                <td>60-69</td>
                <td>Good</td>
              </tr>
              <tr>
                <td><span className="grade-badge grade-d">D</span></td>
                <td>6</td>
                <td>55-59</td>
                <td>Average</td>
              </tr>
              <tr>
                <td><span className="grade-badge grade-e">E</span></td>
                <td>5</td>
                <td>50-54</td>
                <td>Pass</td>
              </tr>
              <tr>
                <td><span className="grade-badge grade-f">F</span></td>
                <td>0</td>
                <td>&lt; 50</td>
                <td>Fail</td>
              </tr>
            </tbody>
          </table>
        </div>
        <p className="grade-note">Formula: Percentage = CGPA × 10</p>
      </section>

      {/* Final CTA */}
      <section className="final-cta">
        <div className="final-cta-content">
          <h2>Ready to Calculate Your CGPA?</h2>
          <p>Join hundreds of VIT students tracking their academic progress</p>
          <Link to="/calculator" className="cta-primary large">
            Start Calculating Now
          </Link>
        </div>
      </section>

      <AdPlaceholder position="bottom" />
    </div>
  );
};

export default Home;
